import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface DialogsProps {
  open: boolean;
  title: string;
  message: string;
  type: 'confirm' | 'info',
  style: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
  onConfirm?: () => void;
  onCancel?: () => void;
}

export type {
  DialogsProps
};

export function Dialogs({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  type,
  style
}: DialogsProps) {

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="confirm-dialog-title" color={style}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      {
        type === 'confirm' ?
          (
            <DialogActions>
              <Button onClick={onCancel} color="inherit">
                {'Cancelar'}
              </Button>
              <Button onClick={onConfirm} color={'error'} variant="contained">
                {'Confirmar'}
              </Button>
            </DialogActions>
          )
          :
          (
            <DialogActions>
              <Button
                onClick={onConfirm}
                color={style}
                variant="contained"
              >
                OK
              </Button>
            </DialogActions >
          )
      }

    </Dialog >
  );
}